import makeStyles from '@mui/styles/makeStyles';
import { FC, useEffect, RefObject } from 'react';
import useSVG from '../../util/hooks/use-svg';
import useTimeout from '../../util/timeout-util';

interface SVGProps {
  svgSrc: string;
  parentRef: RefObject<HTMLDivElement>;
  onLoaded?: (scaleFactor: number, svgNode: SVGSVGElement | null) => void;
  svgWrapperRef: RefObject<HTMLDivElement>;
  scale?: number;
}

const SVG: FC<SVGProps> = ({ svgSrc, onLoaded, parentRef, svgWrapperRef, scale }) => {
  const { svg, fetchSVG, onSVGFetched } = useSVG(svgSrc, parentRef, svgWrapperRef, scale, onLoaded);

  const { addTimeout, cancelAll } = useTimeout();
  const RESIZE_TIMEOUT = 50;

  const classes = useStyles();

  useEffect(() => {
    fetchSVG();

    registerWindowResizeEvents();
    return () => removeWindowResizeEvents();
  }, []);

  const onWindowResize = () => {
    cancelAll();

    addTimeout(() => {
      onSVGFetched();
    }, RESIZE_TIMEOUT);
  };

  const registerWindowResizeEvents = () => {
    window.addEventListener('resize', onWindowResize);
  };

  const removeWindowResizeEvents = () => {
    window.removeEventListener('resize', onWindowResize);
  };

  return (
    <>
      <div
        ref={svgWrapperRef}
        className={classes.root}
        style={{ display: 'none' }}
        dangerouslySetInnerHTML={{ __html: svg }}
      />
      <object
        tabIndex={-1}
        style={{ width: 0, height: 0, position: 'absolute', top: 0, left: 0 }}
        data={svgSrc}
        type="image/svg+xml"
        id="alphasvg"
      />
    </>
  );
};

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
  },
}));

export default SVG;
